export default __webpack_public_path__ + "static/media/BPL_Logo.440a6853.png";